export default {
  title: "Meine Tickets",
  refresh: "Aktualisieren",
  create: "Erstellen",
  id: "Ticket-ID",
  type: "Typ",
  status: "Status",
  createdAt: "Erstellt am",
  actions: "Aktionen",
  detailTitle: "Ticketdetails",
  email: "E-Mail",
  description: "Beschreibung",
  response: "Antwort",
  noResponse: "Noch keine Antwort",
  statusPending: "Ausstehend",
  statusResolved: "Gelöst",
  statusClosed: "Geschlossen",
};
